var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7369 4.7L16.4269 0.85C16.1169 0.33 15.5369 0 14.9269 0H4.05692C3.44692 0 2.86692 0.33 2.55692 0.85L0.246923 4.7C-0.163077 5.39 -0.0530823 6.27 0.506918 6.84L8.24692 14.58C8.58692 14.92 9.03693 15.09 9.48693 15.09C9.93693 15.09 10.3869 14.92 10.7269 14.58L18.4669 6.84C19.0369 6.27 19.1469 5.39 18.7269 4.7H18.7369ZM5.00692 6.51L7.16692 11.37L2.30692 6.51H5.00692ZM10.9869 1.51L12.3869 5.01H6.59693L7.99692 1.51H10.9769H10.9869ZM12.3369 6.51L9.48693 12.91L6.63692 6.51H12.3269H12.3369ZM13.9769 6.51H16.6769L11.8169 11.37L13.9769 6.51ZM15.1369 1.63L17.1669 5.01H13.9969L12.5969 1.51H14.9269C15.0169 1.51 15.0969 1.56 15.1369 1.63ZM3.84693 1.63C3.88693 1.55 3.96692 1.51 4.05692 1.51H6.38692L4.98693 5.01H1.81693L3.84693 1.63Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.849ea5e47087cebe7b7cd1b63a0b59fe.svg";
export { ForwardRef as ReactComponent };